import { colorThemes, type ColorTheme, type ThemeMode } from './theme-config';

export function applyTheme(colorTheme: ColorTheme, mode: ThemeMode) {
  const root = window.document.documentElement;
  
  // Determine actual mode (resolve 'system')
  let actualMode: 'light' | 'dark' = mode === 'system'
    ? window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light'
    : mode;

  // Get theme colors with robust self-healing fallback for stale local storage states
  const theme = colorThemes[colorTheme] || colorThemes['ocean'];
  const colors = theme[actualMode];

  // Apply mode class
  root.classList.remove('light', 'dark');
  root.classList.add(actualMode);

  // Apply color variables
  Object.entries(colors).forEach(([key, value]) => {
    const cssVar = `--${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
    root.style.setProperty(cssVar, value);
  });

  // Store theme info as data attributes for debugging
  root.setAttribute('data-color-theme', colorTheme);
  root.setAttribute('data-mode', actualMode);
}

export function getSystemTheme(): 'light' | 'dark' {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function watchSystemTheme(callback: (theme: 'light' | 'dark') => void) {
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  
  const handler = (e: MediaQueryListEvent) => {
    callback(e.matches ? 'dark' : 'light');
  };

  mediaQuery.addEventListener('change', handler);
  
  return () => mediaQuery.removeEventListener('change', handler);
}
